const base = {
  users: '/users', //9092
  datebook: '/datebook', //9098
  async: '/async', //9097
  config: '/config', //9094
  record: '/record', //9095
};
export default base;



// WEBPACK FOOTER //
// ./src/api/base.js